import React from 'react';
import { Link } from 'react-router-dom';


function Footer() {
  return (
    <footer class="site-footer">
        <div class="row">
          <div class="col-md-6">
            <p class="text-center text-md-left">Copyright © 2024 UBT <Link to="/">Cambodia</Link>. All rights reserved.</p>
          </div>

          <div class="col-md-6">
            <ul class="nav nav-primary nav-dotted nav-dot-separated justify-content-center justify-content-md-end">
              <li class="nav-item">
                {/* <a class="nav-link" href="help/articles.html">Documentation</a> */}
              </li>
              <li class="nav-item">
                {/* <a class="nav-link" href="help/faq.html">FAQ</a> */}
              </li>
              {/* <li class="nav-item">
                <Link class="nav-link" to="https://themeforest.net/item/theadmin-responsive-bootstrap-4-admin-dashboard-webapp-template/20475359?license=regular&amp;open_purchase_for_item_id=20475359&amp;purchasable=source&amp;ref=thethemeio">Purchase Now</Link>
              </li> */}
            </ul>
          </div>
        </div>
      </footer>
  )
}

export default Footer